import { render, staticRenderFns } from "./AddAdminList.vue?vue&type=template&id=be4ca2bc&scoped=true&"
import script from "./AddAdminList.vue?vue&type=script&lang=js&"
export * from "./AddAdminList.vue?vue&type=script&lang=js&"
import style0 from "./AddAdminList.vue?vue&type=style&index=0&id=be4ca2bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ca2bc",
  null
  
)

export default component.exports